import React, {useState, useEffect} from 'react';
import { SiteLink } from '../../components';
import { useStore } from '../../store';
import { useAuth } from '../../auth';
import { LIVE_FEEDS_PAGE_PATH, DARTFISH_PAGE_PATH } from './liveFeedNavPaths';

import { FaChevronDown } from 'react-icons/fa';
//import { SearchBar } from './searchBar';

export function NavBar(props) {
  const open = props.open;
  //const currentLocation = props.currentLocation;
  const { state } = useStore();
  const auth = useAuth();

  const menu = state.menu || { items: [] };
  const currentLocation = state.history && state.history.length > 0 ? state.history[state.history.length - 1].path : '';
  const depth = 1;
  const menuItemElts = menu.items.map((item, index) =>
    <MenuItem item={item} key={index} depth={depth} onCloseMenu={props.onCloseMenu} currentLocation={currentLocation}></MenuItem>
  );

  const signInHref = '/login?returnUrl=' + encodeURIComponent('/members-area');

  const subscribeItem = {
    title: 'Subscribe',
    url: null,
    items: [
      { title: 'Live Stream', url: LIVE_FEEDS_PAGE_PATH },
      { title: 'Adelaide Footy TV', url: DARTFISH_PAGE_PATH },
    ],
  };

  const accountItem = {
    title: 'My account',
    url: null,
    items: [
      { title: 'My account', url: '/members-area' },
      { title: 'Log out', url: null, isLogout: true },
    ],
  };

  const authLinks = auth.user ? (
    <>
      <AccountMenuItem
        item={accountItem}
        onCloseMenu={props.onCloseMenu}
        onLogout={() => { props.onCloseMenu(); auth.signout(); }}
        currentLocation={currentLocation}
      />
      <MenuItem item={subscribeItem} depth={1} onCloseMenu={props.onCloseMenu} currentLocation={currentLocation} />
    </>
  ) : (
    <>
      <li className="navBar__item">
        <SiteLink className="navBar__link" to={signInHref} onClick={props.onCloseMenu}>Sign In</SiteLink>
      </li>
      <MenuItem item={subscribeItem} depth={1} onCloseMenu={props.onCloseMenu} currentLocation={currentLocation} />
    </>
  );

  return (
    <div className={`navBar ${open ? 'navBar--on' : ''}`} id="sliding-menu">
      {/* <SearchBar onCloseMenu={props.onCloseMenu}/> */}
      <div className="navBar__scrollArea" id="top-menu">
        <nav className="navBar_nav">
          <ul>
            {menuItemElts}
            {authLinks}
          </ul>
        </nav>
      </div>

    </div>);

}

function MenuItem(props) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);
  const item = props.item;
  const subItems = item.items || [];
  const currentLocation = props.currentLocation;

  const subItemsElts = subItems.length > 0? subItems.map((subItem, index) =>
    <SubMenuItem item={subItem} key={index} onCloseMenu={props.onCloseMenu} />
  ) : null;


  useEffect(() => {
    //console.log('navbar', currentLocation);
    setSubMenuOpened(false);
  }, [currentLocation])

  function closeMenu() {
    props.onCloseMenu();
  }

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(!subMenuOpened);
  }

  return (
    <li className={`navBar__item ${subMenuOpened ? 'navBar__item--open' : ''}`}>
      <SiteLink className="navBar__link" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
        {subItemsElts && <span className="navBar__icon" onClick={(e) => toggleSubmenu(e)}><FaChevronDown /></span>}
      </SiteLink>
      {subItemsElts &&
        <ul className={`navBar__subMenu`}>
          {subItemsElts}
        </ul>}
    </li>
  )
}

function SubMenuItem(props) {
  const item = props.item;
  function closeMenu() {
    props.onCloseMenu();
  }

  return (
    <li className="navBar__subItem">
      <SiteLink className="navBar__subLink" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
      </SiteLink>
    </li>
  )
}

function AccountMenuItem({ item, onCloseMenu, onLogout, currentLocation }) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);

  useEffect(() => {
    setSubMenuOpened(false);
  }, [currentLocation]);

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(!subMenuOpened);
  }

  return (
    <li className={`navBar__item ${subMenuOpened ? 'navBar__item--open' : ''}`}>
      <SiteLink className="navBar__link" to={item.url} onClick={(e) => { e.preventDefault(); toggleSubmenu(e); }}>
        <span>{item.title}</span>
        <span className="navBar__icon" onClick={toggleSubmenu}><FaChevronDown /></span>
      </SiteLink>
      <ul className="navBar__subMenu">
        {item.items.map((subItem, index) =>
          subItem.isLogout ? (
            <li key={index} className="navBar__subItem">
              <button
                type="button"
                className="navBar__subLink"
                onClick={onLogout}
              >
                <span>{subItem.title}</span>
              </button>
            </li>
          ) : (
            <li key={index} className="navBar__subItem">
              <SiteLink className="navBar__subLink" to={subItem.url} onClick={onCloseMenu}>
                <span>{subItem.title}</span>
              </SiteLink>
            </li>
          )
        )}
      </ul>
    </li>
  );
}